import { connect } from "react-redux";
import ContentContainer from "./components/content-container";

const mapDispatchToProps = (dispatch) => ({
  dispatchGet: (getFunction) => dispatch(getFunction()),
});

export default connect(null, mapDispatchToProps)(ContentContainer);
